export class MissionControlController {
    /*@ngInject*/
    constructor($scope, $state, $filter, $rootScope, $uibModal, $timeout, ngNotify, StorageService, genericService, companyService, userRoleService, planService, MESSAGECONSTANTS, uibModalService, utilityService) {
        this.$scope = $scope;
        this.$state = $state;
        this.$filter = $filter;
        this.$rootScope = $rootScope;
        this.$uibModal = $uibModal;
        this.$timeout = $timeout;
        this.ngNotify = ngNotify;
        this.StorageService = StorageService;
        this.genericService = genericService;
        this.companyService = companyService;
        this.userRoleService = userRoleService;
        this.planService = planService;
        this.MESSAGECONSTANTS = MESSAGECONSTANTS;
        this.uibModalService = uibModalService;
        this.utilityService = utilityService;
    }
    $onInit() {
        this.$stateParams = this.$transition$.params();
        this.$rootScope.switchCompanyRepeat = 0;
        this.$rootScope.switchClicked = false;
        this.$rootScope.CompanySelectedFromPopup = false;
        this.$rootScope.usersEmptyMessage = '';
        this.filterValuesToPassiveCandidates = [];
        this.isInHost = this.utilityService.isInHost();
        if (this.$rootScope.userDetails.roleScreenRef.role.name == 'CorporateAdmin') {
            this.$rootScope.SelectedCompanyId = this.$rootScope.userDetails.company.companyId;
        }
        if (angular.isDefined(this.$rootScope.newlyCreatedCompanyId)) {
            this.$rootScope.SelectedCompanyId = this.$rootScope.newlyCreatedCompanyId;
        }
        this._initScopeApply();
        this._showAllCompaniesIfNeeded();
        this._setHeightOfLeftNavAndContent();
        this._goToLoginIfNeeded();
    }
    /**
  * This method is used to do $scope.$apply()
  * with out breaking any digest cycles
  */
    _initScopeApply() {
        this.$scope.safeApply = function (fn) {
            var phase = this.$root.$$phase;
            if (phase == '$apply' || phase == '$digest') {
                if (fn && (typeof (fn) === 'function')) {
                    fn();
                }
            }
            else {
                this.$apply(fn);
            }
        };
    }
    /**
    * This condition shows popup when entering to missioncontrol application based on different variables
    * (this.$rootScope.userDetails.company.companyId != null) ---> true ; only when user is not in create company flow( 1st step)
    * this.$rootScope.companyDeletedShowPopup ---> true ; only at the point of company deletion untill getting all companies in popup again.
    * this.$rootScope.userDetails.shouldPopupBeDisplayed ---> true ; only if server side api after login returns true;
    * this.$rootScope.userDetails.company.companySelected ---> true ; only if a company is selected from popup.
    * angular.equals(this.StorageService.get('companyDetails'), null) only if a company is not selected from popup.---> true;
    */
    _showAllCompaniesIfNeeded() {
        if (this.$rootScope.userDetails.company.companyId != null || this.$rootScope.companyDeletedShowPopup) {
            this.$rootScope.userDetails.shouldPopupBeDisplayed = true;
            if (this.$rootScope.userDetails.shouldPopupBeDisplayed && !this.$rootScope.userDetails.company.companySelected && angular.equals(this.StorageService.get('companyDetails'), null)) {
                if (this.isSuperUser(this.$rootScope.userDetails.roleScreenRef.role) || this.isFourDotFiveAdmin(this.$rootScope.userDetails.roleScreenRef.role)) {
                    this.$timeout(() => {
                        // this.companyService.showAllCompanies();
                        this.uibModalService.showAllCompanies();
                    }, 1000);
                }
            }
        }
    }
    _goToLoginIfNeeded() {
        if (angular.isUndefined(this.$rootScope.userDetails) || (this.$rootScope.userDetails === null)) {
            this.$state.go('login', null, { reload: true });
        }
    }
    /**
     * This method is used to show or hide functionalities based
     * on role screen ref provided by login api.
     */
    hasAccess(screenId) {
        let accessGranted = false;
        if (this.$rootScope.userDetails && this.$rootScope.userDetails.roleScreenRef && this.$rootScope.userDetails.roleScreenRef.screen) {
            for (let i = 0; i < this.$rootScope.userDetails.roleScreenRef.screen.length; i++) {
                if (this.$rootScope.userDetails.roleScreenRef.screen[i].id === screenId) {
                    accessGranted = true;
                    break;
                }
            }
        }
        return accessGranted;
    }
    ;
    isSuperUser(role) {
        return this.userRoleService.isSuperUser(role);
    }
    isFourDotFiveAdmin(role) {
        return this.userRoleService.isFourDotFiveAdmin(role);
    }
    isRecruiter(role) {
        return this.userRoleService.isRecruiter(role);
    }
    isVendor() {
        return this.companyService.isCompanyVendor();
    }
    isWorkflowScreenActive() {
        return this.$state.current.url == '/candidateJobMatchesWorkflow';
    }
    isUploadReqScreenActive() {
        return this.$state.current.url == '/uploadreq';
    }
    isStaffingCompany() {
        return this.companyService.isStaffingCompany();
    }
    isCorporateCompany() {
        return this.companyService.isCorporateCompany();
    }
    isRecruiterManager(role) {
        return this.userRoleService.isRecruitingManager(role);
    }
    isLoggedInUserCompanyAdmin(role) {
        return this.userRoleService.isLoggedInUserCompanyAdmin(role);
    }
    /**
     * This condition executes at the starting of the page
     * This will maintain same height for both leftnav and the rightside loaded page.
     */
    _setHeightOfLeftNavAndContent() {
        $(document).ready(function () {
            if ($(document).width() < 991) {
                $('#nav-col').addClass('close-sidenav');
            }
            $("#nav-col").addClass("vertilizeheight");
            $('#menubars').click(function () {
                $("#nav-col").toggleClass("vertilizeheight", 200, "linear");
            });
        });
        /**
        * This function is used to hide and show admin menu icon in left nav
        * @ current implementation is if no child menu items available
        * 	 for admin menu icon, then it will be hidden
        */
        // this.$timeout(function () {
        //     var myList = document.getElementById('adminmenulist');
        //     if (!(myList.children.length > 0)) {
        //         angular.element(document.getElementById('adminmenu')).css("display", "none");
        //     }
        // }, 800)
    }
}
MissionControlController.$inject = ['$scope', '$state', '$filter', '$rootScope', '$uibModal', '$timeout', 'ngNotify', 'StorageService', 'genericService', 'companyService', 'userRoleService', 'planService', 'MESSAGECONSTANTS', 'uibModalService', 'utilityService'];
// import * as TEMPLATE from './mission-control.html';
import * as TEMPLATE from 'raw-loader!./mission-control.html';
export const MissionControlComponent = {
    selector: 'missioncontrol',
    component: {
        bindings: { $transition$: '<' },
        // templateUrl: 'app/partials/missioncontrol/mission-control.html',
        template: TEMPLATE.default,
        controller: MissionControlController
    }
};
//# sourceMappingURL=mission-control.component.js.map